import { render, staticRenderFns } from "./ReadXlsFile.vue?vue&type=template&id=5f38e340"
import script from "./ReadXlsFile.vue?vue&type=script&lang=js"
export * from "./ReadXlsFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports